import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import {CategoriaDocumento} from '../../../../model/class/CategoriaDocumento';
import { GeneralService } from '../../../services/general/general.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastsManager} from 'ng2-toastr';
import {CategoriaDocumentosService} from '../../../services/categoria-documentos/categoria-documentos.service';

@Component({
  selector: 'app-crear-categorias-documentos',
  templateUrl: './crear-categorias-documentos.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./crear-categorias-documentos.component.css']
})
export class CrearCategoriasDocumentosComponent implements OnInit {

  @Input() newCategoria: CategoriaDocumento;
  editando = false;

  loaders = {
    form: false
  };

  constructor(
    private _generalService: GeneralService,
    public activeModal: NgbActiveModal,
    private toasts: ToastsManager,
    private categoriaDocumentosService: CategoriaDocumentosService
  ) { }

  ngOnInit() {

    if (this.newCategoria.id) {
      this.editando = true;
    } else {
      this.newCategoria.publicada = true;
    }
  }

  onSubmit() {
    this.loaders.form = true;
    if (this.editando) {
      this.categoriaDocumentosService.edit(this.newCategoria.id, this.newCategoria.getFormData())
        .subscribe(
          (data) => {
            this.loaders.form = false;
            this.toasts.success(`La Categoria a sido modificada exitosamente.`);
            this._generalService.revalidarPathCache('category').subscribe();
            this.activeModal.close(data.data);
          }, (error) => {
            this.loaders.form = false;
            this.toasts.error(`Ha ocurrido un error al modificar la categoria.`);

          }
        );
    } else {

      const objCategoria = new CategoriaDocumento(this.newCategoria);

      this.categoriaDocumentosService.create(objCategoria.getFormData())
        .subscribe(
          (data) => {
            this.loaders.form = false;
            this.toasts.success(`La Categoria a sido creada exitosamente.`);
            this._generalService.revalidarPathCache('category').subscribe();
            this.activeModal.close(data.data);
          }, (error) => {
            this.loaders.form = false;
            this.toasts.error(`Ha ocurrido un error al crear la categoria.`);

          }
        );
    }

  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/crear-categorias-documentos/crear-categorias-documentos.component.ts